module.exports = __webpack_public_path__ + "static/media/LK_Close.e02ef4ea.svg";